import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DiffusionVisualApiService } from '@_services/api/diffusion-visual-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedDiffusionVisualEffects } from './diffusion-visual-generated.effects';

@Injectable()
export class DiffusionVisualEffects extends GeneratedDiffusionVisualEffects {
  constructor(actions$: Actions, diffusionVisualApiService: DiffusionVisualApiService, store$: Store<AppState>) {
    super(actions$, diffusionVisualApiService, store$);
  }
}
